import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .company__avatar {
    display: inline-block;
    background: ${colors.profile.normal};
    border-radius: 100%;
    width: 50px;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    color: ${colors.profile.light};
    display: inline-block;
    margin-right: 20px;
    text-align: center;
    transition: all 0.3s ease-in-out;
  }
`;



// WEBPACK FOOTER //
// ./src/components/support/avatar/styles.js